/**
 * Coupon view
 */
export var CouponView;
(function (CouponView) {
    /**
     * Show default coupon flyout / card
     */
    CouponView["DEFAULT"] = "DEFAULT";
    /**
     * Show coupon as label on hotel card
     */
    CouponView["LABEL"] = "LABEL";
    /**
     * Show exit intent coupon
     */
    CouponView["EXIT_INTENT"] = "EXIT_INTENT";
})(CouponView || (CouponView = {}));
export default CouponView;
